/**
 * 所有组件的公共方法
 * wangz
 * 2018.3.9
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { AllCompGUID } from "rt-sd-common/sgiConstants/SgiCompConstant";
import { SgiFormText } from "./SgiFormText";
import { SgiFormTextArea } from "./SgiFormTextArea";
import { SgiFormInputNumber } from "./SgiFormInputNumber"
import { SgiFormSelect } from './SgiFormSelect'
import { SgiFormRadio } from './SgiFormRadio'
import { SgiFormCheckboxGroup } from './SgiFormCheckboxGroup'
import { SgiFormCheckbox } from './SgiFormCheckbox'
import { SgiFormTimePicker } from './SgiFormTimePicker'
import { SgiFormDatePicker } from './SgiFormDatePicker'
import { SgiFormUpload } from './SgiFormUpload'
import { SgiButton } from './SgiButton'
import { SgiForm } from "./SgiForm";
import { SgiRow } from "./SgiRow";
import { SgiCol } from "./SgiCol";
import { SgiTabs } from "./SgiTabs";
import { SgiPanel } from "./SgiPanel";
import { SgiTable } from "./SgiTable";
import { SgiTree } from "./SgiTree";
import { SgiCard } from "./SgiCard";
import { SgiCollapse } from "./SgiCollapse";
import { SgiMainComp } from "./SgiMainComp";
import { uuid, uuidDate } from "rt-sd-common/sgiCommon/sgiCommon";
import { ComponentManager } from 'rt-sd-common/sgiFactory/ComponentManager'
import { SgiFormTreeSelect } from "./SgiFormTreeSelect";
import { SgiToolbar } from "./SgiToolbar";
import { SgiFormInputSearch } from "./SgiFormInputSearch";
import { SgiNest } from "./SgiNest";
import { SgiQuote } from "./SgiQuote";
import { SgiMenu } from "./SgiMenu";
import { SgiSteps } from "./SgiSteps";
import { SgiSplitter } from './SgiSplitter';
import { SgiIcon } from './SgiIcon';
import { SgiImg } from './SgiImg';
import { SgiLabel } from './SgiLabel';
import { SgiTag } from './SgiTag';
import { SgiFormCascader } from './SgiFormCascader';
import { SgiList } from './SgiList';
import { SgiTile } from './SgiTile';
import SgiCommEcharts from './SgiCommEcharts';
import { SgiCalendar } from './SgiCalendar';
import { SgiEditor } from './SgiEditor';
import SgiEChartsCommon from './sgiECharts/SgiEChartsCommon';
import SgiOverlap from './SgiOverlap';
import sgiConstants from 'rt-sd-common/sgiConstants/sgiConstants';
import { Icon } from 'antd';
import { SgiDV } from './SgiDV';
import { SgiTV } from './SgiTV';
import { tool } from 'rt-sd-common/sgiCommon/sgiRunningCommon';
import SgiCodeMirror from './SgiCodeMirror';
import SgiFormCodeMirror from './SgiFormCodeMirror';
import SgiJsoneditor from './SgiJsoneditor';
import SgiG6Common from './sgiG6/SgiG6Common';
import { getConstByKey, testReactVsn } from './sgiBaseComp/SgiCommon';

/**
* 根据类型转换为指定控件
* @param {描述信息} moduleDesc
* @param {属性} formProps
*/
var convertModuleByGuid = function (currentModule, moduleDesc, bdInst, objFct, type, parameters) {

    var mdType = moduleDesc.desId;
    var cId = getConstByKey(currentModule, moduleDesc.cId);
    let module;
    if (mdType === AllCompGUID.UCV) { //主main
        if (!cId) cId = "mainUcv_" + uuid(8);
        module = <SgiMainComp ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.WV) {//form
        if (!cId) cId = "form_" + uuid(8);
        module = <SgiForm ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters}
            /*setActiveWV={setActiveWV}*/ />
    } else if (mdType === AllCompGUID.DV) {//dv
        if (!cId) cId = "dv_" + uuid(8);
        module = <SgiDV ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters}
            /*setActiveWV={setActiveWV}*/ />
    } else if (mdType === AllCompGUID.SPLITTER) {//分割窗
        if (!cId) cId = "spliter_" + uuid(8);
        module = <SgiSplitter ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.TAB) {//tab
        if (!cId) cId = "tab_" + uuid(8);
        module = <SgiTabs ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.CARD) { //card
        if (!cId) cId = "card_" + uuid(8);
        module = <SgiCard ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.OVERLAP) { //新层叠面板
        if (!cId) cId = "overlap_" + uuid(8);
        module = <SgiOverlap ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.ACCORDION) { //折叠面板
        if (!cId) cId = "collapse_" + uuid(8);
        module = <SgiCollapse ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.FIELDSET) { //组控件

    } else if (mdType === AllCompGUID.PANEL) { //普通面板
        // var setActiveWV;
        // if (parameters && parameters["setActiveWV"]) {
        //     setActiveWV = parameters["setActiveWV"];
        // }

        if (!cId) cId = "panel_" + uuid(8);
        module = <SgiPanel ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters}
            /*setActiveWV={setActiveWV}*/ />
    } else if (mdType === AllCompGUID.NEST) {//嵌入面板
        if (!cId) cId = "nest_" + uuid(8);
        module = <SgiNest ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.QUOTE) {//组件的引用
        if (!cId) cId = "quote_" + uuid(8);
        module = <SgiQuote ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.TPL) { //模板

    } else if (mdType === AllCompGUID.CONTAINER) {//自定义面板

    } else if (mdType === AllCompGUID.DVPANEL) {//DVPANEL

    } else if (mdType === AllCompGUID.DU) {

    } else if (mdType === AllCompGUID.FLOATWINDOW) { //浮动面板

    } else if (mdType === AllCompGUID.MENU) {//菜单
        if (!cId) cId = "menu_" + uuid(8);
        module = <SgiMenu ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    }
    /**
     * 创建基本控件
     * 创建方法 创建物理控件。
     */
    else if (mdType === AllCompGUID.FIELDTEXT) { //文本框
        if (!cId) cId = "text_" + uuid(8);
        module = <SgiFormText ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.NUMBER) { //数字控件
        if (!cId) cId = "num_" + uuid(8);
        module = <SgiFormInputNumber ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.COMBOBOX) { //下拉框
        if (!cId) cId = "select_" + uuid(8);
        module = <SgiFormSelect ref={cId} key={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.COMBOXTREE) {//下拉树
        if (!cId) cId = "treeselect_" + uuid(8);
        module = <SgiFormTreeSelect ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.COMBOXGRID) {//下拉表格

    } else if (mdType === AllCompGUID.RADIOGROUP) {//单选框
        if (!cId) cId = "radio_" + uuid(8);
        module = <SgiFormRadio ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.CHECKBOXGROUP) {//多选框
        if (!cId) cId = "ck_" + uuid(8);
        module = <SgiFormCheckboxGroup ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.CASCADER) {//多选框
        if (!cId) cId = "cas_" + uuid(8);
        module = <SgiFormCascader ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.TIME) {//时间
        if (!cId) cId = "time_" + uuid(8);
        module = <SgiFormTimePicker ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.DATE) {//日期
        if (!cId) cId = "date_" + uuid(8);
        module = <SgiFormDatePicker ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.FILE) {//文件
        if (!cId) cId = "file_" + uuid(8);
        module = <SgiFormUpload ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.UPLOADFILE) {//上传
        if (!cId) cId = "file_" + uuid(8);
        module = <SgiFormUpload ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.TEXTAREA) {//文本域
        if (!cId) cId = "txta_" + uuid(8);
        module = <SgiFormTextArea ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.EDITORAREA) {//富文本
        if (!cId) cId = "editor_" + uuid(8);
        module = <SgiEditor ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.CODEMIRROR_FORM) {//codemirror-form
        if (!cId) cId = "codemirror_form_" + uuid(8);
        module = <SgiFormCodeMirror ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.BUTTON) {//按钮
        if (!cId) cId = "btn_" + uuid(8);
        module = <SgiButton ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.CHECKBOX) {//checkbox
        if (!cId) cId = "ck_" + uuid(8);
        module = <SgiFormCheckbox ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.COLOR) {

    } else if (mdType === AllCompGUID.FONT) {

    } else if (mdType === AllCompGUID.PASSWORD) {//密码

    } else if (mdType === AllCompGUID.MONETARYTEXT) {  //金额控件

    } else if (mdType === AllCompGUID.TOOLBAR) {  //工具条
        if (!cId) cId = "toba_" + uuid(8);
        module = <SgiToolbar ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.TBFILL) {  //工具条占位符

    } else if (mdType === AllCompGUID.POPUI) {  //弹出窗
        if (!cId) cId = "popui_" + uuid(8);
        module = <SgiFormInputSearch ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.EDITOR) {  //富文本
        if (!cId) cId = "editor_" + uuid(8);
        module = <SgiEditor ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.TREE) {
        if (!cId) cId = "tree_" + uuid(8);
        module = <SgiTree ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.TABLE) {
        if (!cId) cId = "table_" + uuid(8);
        module = <SgiTable ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.TV) {
        if (!cId) cId = "tv_" + uuid(8);
        module = <SgiTV ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.LINE) { //折线图

    } else if (mdType === AllCompGUID.AREA) { //面积图

    } else if (mdType === AllCompGUID.BAR) { //条形图

    } else if (mdType === AllCompGUID.SCATTER) { //散点图

    } else if (mdType === AllCompGUID.PIE) { //饼图

    } else if (mdType === AllCompGUID.GAUGE) { //表盘图

    } else if (mdType === AllCompGUID.RADAR) { //雷达图

    } else if (mdType === AllCompGUID.PROGRESSBAR) { //进度条

    } else if (mdType === AllCompGUID.IMG) { //图片控件
        if (!cId) cId = "img_" + uuid(8);
        module = <SgiImg ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.LIST) { //列表控件
        if (!cId) cId = "list_" + uuid(8);
        module = <SgiList ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.ICON) { //图标
        if (!cId) cId = "icon_" + uuid(8);
        module = <SgiIcon ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.LABEL) { //标签控件
        if (!cId) cId = "label_" + uuid(8);
        module = <SgiLabel ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.TAG) { //tag
        if (!cId) cId = "tag_" + uuid(8);
        module = <SgiTag ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.FIELDDISPLAY) { //只读文本控件

    } else if (mdType === AllCompGUID.COMPONENT) { //自定义标签

    } else if (mdType === AllCompGUID.STATBUTTON) { //状态按钮

    } else if (mdType === AllCompGUID.STEP) { //步骤控件
        if (!cId) cId = "steps_" + uuid(8);
        module = <SgiSteps ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.MONETARY2TEXT) {  //金额控件

    } else if (mdType === AllCompGUID.PASSWORDSTRENGTH) {  //密码强度控件//增加密码强度控件20170928-wangj

    } else if (mdType === AllCompGUID.ITEM) {  //

    } else if (mdType === AllCompGUID.DIVCOMBOBOX) {  //自定义下拉窗

    } else if (mdType === AllCompGUID.EC_COMMON) {  //ECharts自定义
        if (!cId) cId = "EChartsCommon_" + uuidDate(6, "yyyyMMddhhmmssSSS");
        module = <SgiEChartsCommon ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.Tile) {  //平铺组件
        if (!cId) cId = "tile_" + uuid(8);
        module = <SgiTile ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.CommEcharts) {  //通用图表控件
        if (!cId) cId = "commEcharts_" + uuid(8);
        module = <SgiCommEcharts ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.Calendar) {  //日历
        if (!cId) cId = "calendar_" + uuid(8);
        module = <SgiCalendar ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.CODEMIRROR) {  //codemirror
        if (!cId) cId = "codemirror_" + uuid(8);
        module = <SgiCodeMirror ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.JSONEDITOR) {  //jsoneditor
        if (!cId) cId = "jsoneditor_" + uuid(8);
        module = <SgiJsoneditor ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.G6_COMMON) {  //g6-common
        if (!cId) cId = "g6_common_" + uuid(8);
        module = <SgiG6Common ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    }

    //创建布局
    else if (mdType === AllCompGUID.LT_ROW) { //行
        if (!cId) cId = "ltrow_" + uuid(8);
        module = <SgiRow ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    } else if (mdType === AllCompGUID.LT_COL) { //列
        if (!cId) cId = "ltcol_" + uuid(8);
        module = <SgiCol ref={cId} key={cId} parentModule={currentModule}
            moduleDesc={moduleDesc} bdInst={bdInst} objFct={objFct} type={type} {...parameters} />
    }
    // ComponentManager.set(uid, cId, module);
    return module;
}

let refFunction = function (ctl) {

    if (!ctl || !ctl.props || !ctl.props.moduleDesc) {
        return;
    }
    // tool.sgiLogger.log("refFunction", ctl.props.moduleDesc.cId);
    // tool.sgiLogger.log("refFunction", ctl.props.moduleDesc.desId);
    let { moduleDesc, objFct } = ctl.props;
    let itemKey = getConstByKey(ctl, moduleDesc.cId);
    if (!itemKey) {
        return;
    }
    ComponentManager.set(objFct.getUID(), itemKey, ctl);
}

let refModalFunction = function (ctl) {

    if (!ctl) {
        return;
    }
    let { moduleDesc, objFct } = ctl.props;
    let mainComp = ComponentManager.get(objFct.getUID(), objFct.getUID());
    mainComp.setModal(ctl);
}

// 弹出组件与父组件使用不同对象工厂时使用
let refModalFunction2 = function (ctl) {

    if (!ctl) {
        return;
    }
    let { moduleDesc, objFct } = ctl.props;
    let pObjFct = objFct.getParent();
    if (pObjFct) {
        let mainComp = ComponentManager.get(pObjFct.getUID(), pObjFct.getUID());
        mainComp.setModal(ctl);
    }
}

// 数据与组件控制交互
let getPropsFromItem = function (item, cstmConst = {}) {
    if (!item || Object.prototype.toString.call(item) !== "[object Object]") return {};

    let props = {};
    for (const key in item) {
        if (cstmConst[key] || sgiConstants[key]) {
            let pkey = cstmConst[key] || sgiConstants[key];
            switch (pkey) {
                case "icon"://图标特殊处理
                    if (typeof item[key] === "string") {
                        props[pkey] = <Icon type={item[key]} />;
                    } else if (Object.prototype.toString.call(item[key]) === "[object Object]") {
                        props[pkey] = <Icon {...item[key]} />;
                    }
                    break;
                default:
                    props[pkey] = item[key];
                    break;
            }
        }
    }

    return props;
}

// 将convertModuleByGuid方法设置成全局方法
if (tool) tool.convertModuleByGuid = convertModuleByGuid;

/**
 * 通用服务接口调用处理
 */
function toCallSi(moduleDesc, objFct) {
    if (!moduleDesc || !objFct || !moduleDesc.bdSI) return;

    // 服务号去掉前后空格
    let bdSI = moduleDesc.bdSI.trim();
    if (!bdSI) return;

    let req = {}
    // 前处理
    let callPre = moduleDesc.callPre; // 用户自定义点击前处理事件
    if (callPre) {
        try {
            // 自定义前处理
            let $callPre = new Function("module", "objFct", callPre);
            // 返回false，不再调用服务
            if ($callPre(this, objFct) === false) {
                return
            }
        } catch (error) {
            tool.sgiLogger.error(error);
        }
    }

    // 请求体
    if (moduleDesc.reqIst) {
        req = objFct.get(moduleDesc.reqIst);
    }

    // 辅助信息
    let assistBody = {};
    if (moduleDesc.assistBody) {
        assistBody = objFct.get(moduleDesc.assistBody);
    }

    // 后处理
    let callback = (res) => {
        if (res && res.head && res.head.code === "0000") {
            // 服务成功
            try {
                // 提示
                let succMsg = moduleDesc.succMsg;
                if (succMsg) {
                    let msg = eval(`(\`${succMsg}\`)`);
                    tool.sgiLogger.info(msg, res);
                    tool.popMessage(msg, "success");
                }

                if (moduleDesc.resIst) {
                    objFct.set(moduleDesc.resIst, res.body);
                }

                // 刷新
                let refreshID = moduleDesc.refreshID;
                if (refreshID) {
                    let ids = refreshID.split(",");
                    ids.forEach((id) => tool.commonRefresh(id, objFct));
                }
            } catch (error) {
                tool.sgiLogger.error(error);
            }
        } else {
            // 服务失败
            try {
                // 提示
                let failMsg = moduleDesc.failMsg;
                if (failMsg) {
                    let msg = eval(`(\`${failMsg}\`)`);
                    tool.sgiLogger.error(msg, res);
                    tool.popMessage(msg, "warning");
                }
            } catch (error) {
                tool.sgiLogger.error(error);
            }
        }
        // 自定义后处理
        let callAft = moduleDesc.callAft;
        if (callAft) {
            let $callAft = new Function("module", "objFct", "res", callAft);
            $callAft(this, objFct, res);
        }
    };

    // 服务调用
    let async = moduleDesc.async;
    let batchTBID = moduleDesc.batchTBID;
    if (batchTBID) {
        // 分批
        tool.tableBatchSelectSI(batchTBID, objFct, bdSI, req, async, 1, callback, null, assistBody);
    } else {
        // 不分批
        commonClient.callSI(bdSI, objFct, req, async, callback, "POST", assistBody);
    }
}

export { convertModuleByGuid, refFunction, refModalFunction, refModalFunction2, getPropsFromItem, toCallSi };
export default { convertModuleByGuid, refFunction, refModalFunction, refModalFunction2, getPropsFromItem };



// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiCompComm.js